import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';

export const customPriceFormTypeSchema = z
  .object({
    isFixedPrice: z.boolean(),
    isPriceWithVat: z.boolean(),
    amount: z.number().nullish(),
    currency: z.string(),
    isUniformVatType: z.boolean(),
    vatType: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.isFixedPrice && isNil(data.amount)) {
      ctx.addIssue({
        path: ['amount'],
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
      });
    }
    if (data.isFixedPrice && data.isUniformVatType && !data.vatType) {
      ctx.addIssue({
        path: ['vatType'],
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
      });
    }
  });

export type CustomPriceFormType = z.infer<typeof customPriceFormTypeSchema>;
